import * as React from 'react';
import { Checkbox as CheckboxStandard, CheckboxGroup as CheckboxGroupStandard } from '@emorg-prd/standard-react';
import './Checkbox.css';

export type CheckboxState = 'em-is-valid' | 'em-has-error' | 'em-is-disabled' | 'em-is-readonly';

interface CheckboxProps extends Omit<React.ComponentProps<typeof CheckboxStandard>, 'state'> {
	className?: string;
	state?: CheckboxState;
}

interface CheckboxGroupProps extends Omit<React.ComponentProps<typeof CheckboxGroupStandard>, 'state'> {
	className?: string;
	state?: CheckboxState;
}

const Checkbox: React.FC<CheckboxProps> & { Group: React.FC<CheckboxGroupProps> } = (props) => {
	const { className, ...rest } = props;
	return (
		<CheckboxStandard
			{...rest}
			optionalClass={`custom-checkbox ${className ? ` ${className}` : ''}`}
		/>
	);
};

const CheckboxGroup: React.FC<CheckboxGroupProps> = (props) => {
	const { className, state, ...rest } = props;
	const filteredState = state === 'em-is-readonly' ? undefined : state;
	return (
		<CheckboxGroupStandard
			{...rest}
			state={filteredState}
			optionalClass={className}
		/>
	);
};

Checkbox.Group = CheckboxGroup;

export { Checkbox };
